<template>
	<el-drawer title="子轮播" :visible.sync="dialogFormChilden" :with-header="false" size="86%" :before-close="handleClose"
		:modal-append-to-body="false" :wrapperClosable="false" :close-on-press-escape="false">
		<div class="h-full flex flex-dc" v-if="dialogFormChilden">
			<div class="drawer_title pall-30 flex flex-jb flex-n">
				<div class="fs-18 fw-bold">子轮播</div>
				<i class="el-icon-close fs-20 pointer" @click="handleClose"></i>
			</div>
			<div class="primary-btn flex flex-je pall-30">
				<el-button type="primary" size="medium" @click="addDomain">新增</el-button>
			</div>
			<TableHeightFull class="tableDiv pall-30">
				<!-- 表格 -->
				<EleTable ref="tableRef" slot="table" :tableData="tableData" :columns="columns" height="100%" :border="false"
					v-loading="tabLoading" :row-style="{ cursor: 'pointer' }">
					<template v-slot:img="scope">
						<img :src="scope.row.imgUrl" alt="" class="tableImg" v-if="scope.row.imgUrl">
					</template>
				</EleTable>
			</TableHeightFull>
			<!-- 新增子级弹框 -->
			<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" top="20vh" width="30%" append-to-body
				@close="resetForm">
				<template>
					<el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="轮播图名称" prop="slideName" v-if="'slideName' in ruleForm"
							:rules="{required: true, message: '商品名称不能为空', trigger: 'blur'}">
							<el-input type="text" v-model="ruleForm.slideName"></el-input>
						</el-form-item>
						<el-form-item label="系列类型" prop="boxType" v-if="ruleForm.boxType"
							:rules="[{required: true,type: 'number', message: '请至少选择一个系列类型', trigger: 'change'}, { type: 'number'}]">
							<el-select v-model="ruleForm.boxType" placeholder="请选择" @change="handleBoxChang">
								<el-option v-for="item in boxTypes" :key="item.value" :label="item.key" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="系列名称" prop="seriesId"
							:rules="{required: true, message: '请至少选择一个商品系列', trigger: 'change'}">
							<el-select v-model="ruleForm.seriesId" filterable placeholder="请选择" @change="handleSeriesChang">
								<el-option v-for="item in seriesList" :key="item.id" :label="item.seriesName" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="图片" prop="imgUrl" v-if="'imgUrl' in ruleForm"
							:rules="{required: true, message: '图片不能为空', trigger: 'blur'}">
							<upload-file upStyle="width: 80px; height: 80px; border-radius: 5px; overflow: hidden;"
								iconName="el-icon-upload" iconSize="26" v-model="ruleForm.imgUrl"></upload-file>
						</el-form-item>
						<el-form-item label="	排序" prop="sort" v-if="'sort' in ruleForm">
							<el-input type="number" v-model="ruleForm.sort"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogFormVisible = false">取 消</el-button>
						<el-button type="primary" @click="affirmPopup('ruleForm')" :loading="butLoading">确 定</el-button>
					</div>
				</template>
			</el-dialog>
		</div>
	</el-drawer>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	export default {
		components: {
			"UploadFile": (resolve) => require(["@/components/UploadFile"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
		},
		computed: {
			...mapState('menu', {
				'boxTypes': state => state.dictList ? state.dictList.box_type : [], //优惠劵类型
			})
		},
		data() {
			return {
				dialogFormChilden: false,
				dialogFormVisible: false, //新增弹窗
				parentId: '',
				dialogTitle: '新增子级',
				butLoading: false,
				tabLoading: false,
				tableData: [],
				seriesList: [],
				ruleForm: {
					slideName: '', //轮播图名称
					boxType: 3, //盒子类型
					seriesName: '', //系列名称
					seriesId: '', //系列Id
					imgUrl: '', //图片地址
					sort: '', //排序
					parent: '', //父级id
				},
				columns: [{
					label: '排序',
					prop: 'sort',
					align: 'left',
					width: '100',
					'show-overflow-tooltip': true
				}, {
					columnType: 'custom',
					label: '轮播图',
					prop: 'img',
					align: 'left',
					width: '100'
				}, {
					columnType: 'fun',
					label: '系列类型',
					prop: 'boxType',
					align: 'left',
					'show-overflow-tooltip': true,
					formatData: (e) => {
						let ele = this.boxTypes.find(ele => ele.value == e)
						return ele ? ele.key : e
					}
				}, {
					label: '系列名称',
					prop: 'seriesName',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					columnType: 'button',
					label: '操作',
					align: 'right',
					fixed: 'right',
					width: '250',
					buttons: [{
						type: 'text',
						text: '编辑',
						fn: this.editList,
					}, {
						type: 'text',
						text: '删除',
						fn: this.deleteList,
					}],
				}],
			}
		},
		methods: {
			init(id) {
				if (id) {
					this.ruleForm.parent = id
					this.parentId = id
					this.findSlideShowByParent(id)
				}
				this.dialogFormChilden = true
			},
			//获取商品系列列表
			handleBoxChang(even) {
				if (even == 3) {
					this.$http.get('/boxSeries/findBoxSeriesAll').then((result) => {
						this.seriesList = result.data.data
					})
				} else if (even == 5) {
					this.$http.get('/goodSeries/finGoodSeriesAll').then((result) => {
						this.seriesList = result.data.data
					})
				}
			},
			//选择系列
			handleSeriesChang(even) {
				this.ruleForm.seriesName = this.seriesList.filter(ele => ele.id == even)[0].seriesName
			},
			// 根据父级id查询子级信息
			findSlideShowByParent(id) {
				this.$http.get(`slideShow/findSlideShowByParent?id=${id}`).then(({
					data: result
				}) => {
					this.tableData = result.data
				})
			},
			//确认弹框
			affirmPopup(ruleForm) {
				this.$refs[ruleForm].validate((valid) => {
					if (valid) {
						this.butLoading = true
						let apiUrl = ''
						if (this.dialogTitle == '新增子级') {
							apiUrl = '/slideShow/addSlideShow'
						} else if (this.dialogTitle == '编辑子级') {
							apiUrl = '/slideShow/editSlideShow'
						};
						this.$http.post(apiUrl, this.ruleForm).then((result) => {
							this.dialogFormVisible = false
							this.findSlideShowByParent(this.parentId)
							this.$message({
								message: this.dialogTitle + '成功',
								type: 'success'
							})
							this.butLoading = false
						}).catch(err => {
							this.butLoading = false
						})
					}
				})
			},
			//删除
			deleteList(row) {
				this.$confirm('您确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post('/slideShow/removeSlideShowById', {
						id: row.id
					}).then(({
						data: result
					}) => {
						this.findSlideShowByParent(this.parentId)
						this.$message({
							message: '删除成功',
							type: 'success'
						})
					})
				}).catch(_ => {})
			},
			//编辑子级列表
			editList(row) {
				this.dialogTitle = '编辑子级'
				this.dialogFormVisible = true
				this.ruleForm = JSON.parse(JSON.stringify(row)) //排序
				this.handleBoxChang(row.boxType)
			},
			addDomain() {
				this.dialogFormVisible = true
				this.ruleForm.parent = this.parentId
				this.ruleForm.sort = this.tableData.length > 0 ? this.tableData.length + 1 : 1 //排序
				this.handleBoxChang(3)
			},
			//关闭弹框
			handleClose() {
				this.dialogFormChilden = false
			},
			removeDomain(index) {
				this.ruleForm.splice(index, 1)
			},
			//重置清除校验
			resetForm() {
				Object.assign(this.ruleForm, this.$options.data().ruleForm)
				this.$nextTick(() => {
					this.$refs.ruleForm.clearValidate()
					this.$refs.ruleForm.resetFields()
				})
			},
		}
	}
</script>
<style>
	.primary-btn {
		width: 100%;
		box-sizing: border-box;
	}
</style>